import { gsap } from 'gsap'
import { module } from 'modujs'
import { $body } from '../utils/dom'

export default class extends module {
  init() {
    this.animate = this.animate.bind(this)
    this.initTL = this.initTL.bind(this)

    window.addEventListener('p-loaded', this.initTL)
    window.addEventListener('p-animate', this.animate)
  }

  initTL() {
    setTimeout(() => {
      if ($body.classList.contains('home')) {
        this.TL = this.animateHome()
      }
      else if ($body.classList.contains('page-template-tpl-about')) {
        this.TL = this.animateAbout()
      }
      else if ($body.classList.contains('page-template-tpl-solutions')) {
        this.TL = this.animateSolutions()
      }
      else if ($body.classList.contains('single-solution')) {
        this.TL = this.animateSolution()
      }
      else if ($body.classList.contains('page-template-tpl-contact')) {
        this.TL = this.animateContact()
      }
      else if ($body.classList.contains('page-template-default')) {
        this.TL = this.animateDefault()
      }
    }, 400)
  }

  animate() {
    this.TL?.play()
  }

  animateHome() {
    const tl = gsap.timeline({
      paused: true,
      onStart: () => {
        this.call('startTimer', 'HomeHeader')
      }
    })

    if (this.el.querySelector('.c-home-header .c-button-icon')) {
      tl.fromTo(
        this.el.querySelector('.c-home-header .c-button-icon'),
        { scale: 0 },
        {
          scale: 1,
          duration: 0.6,
          ease: 'expo.out'
        },
        0.2
      )
    }

    return tl
  }

  animateAbout() {
    const tl = gsap.timeline({ paused: true })
    let delay = 0

    if (this.el.querySelector('.o-header .-surtitle')) {
      tl.call(
        () => {
          this.el.querySelector('.o-header .-surtitle').classList.add('is-inview')
        },
        null,
        0
      )
      delay += 0.3
    }

    if (this.el.querySelector('.o-header .-h1')) {
      tl.call(
        () => {
          this.el.querySelector('.o-header .-h1').classList.add('is-inview')
        },
        null,
        delay
      )
    }

    if (this.el.querySelector('.o-header .c-button-icon')) {
      tl.fromTo(
        this.el.querySelector('.o-header .c-button-icon'),
        { scale: 0 },
        {
          scale: 1,
          duration: 0.6,
          ease: 'expo.out'
        },
        1
      )
    }

    return tl
  }

  animateSolutions() {
    const tl = gsap.timeline({
      paused: true,
      onStart: () => {
      // If hash in URL, clean it and scroll to section
        const hash = new URL(document.URL).hash

        if (hash) {
          if (hash.includes('#eng', 0)) {
            setTimeout(() => {
              this.call(
                'scrollTo',
                document.querySelector('[data-scroll-target="taxo-6"]'),
                'Scroll'
              )
            }, 200)
          }

          if (hash.includes('#apu', 0)) {
            setTimeout(() => {
              this.call(
                'scrollTo',
                document.querySelector('[data-scroll-target="taxo-7"]'),
                'Scroll'
              )
            }, 200)
          }
        }
      }
    })

    if (this.el.querySelectorAll('.o-header .-surtitle')) {
      this.el.querySelectorAll('.o-header .-surtitle').forEach((element, index) => {
        tl.call(
          () => {
            element.classList.add('is-inview')
          },
          null,
          0.6 * index
        )
      })
    }
    if (this.el.querySelectorAll('.o-header .-h2')) {
      this.el.querySelectorAll('.o-header .-h2').forEach((element, index) => {
        tl.call(
          () => {
            element.classList.add('is-inview')
          },
          null,
          0.1 + (0.6 * index)
        )
      })
    }

    return tl
  }

  animateSolution() {
    const tl = gsap.timeline({ paused: true })
    let delay = 0

    if (this.el.querySelector('.o-header .-h1')) {
      tl.call(
        () => {
          this.el.querySelector('.o-header .-h1').classList.add('is-inview')
        },
        null,
        delay
      )
      delay += 0.35
    }

    if (this.el.querySelector('.o-header_description')) {
      tl.call(
        () => {
          this.el.querySelector('.o-header_description').classList.add('is-inview')
        },
        null,
        delay
      )
    }

    if (this.el.querySelector('.o-header_description .-c2')) {
      tl.call(
        () => {
          this.el.querySelector('.o-header_description .-c2').classList.add('is-inview')
        },
        null,
        delay
      )
      delay += 0.65
    }

    if (this.el.querySelector('.o-header .c-button-icon')) {
      tl.fromTo(
        this.el.querySelector('.o-header .c-button-icon'),
        { scale: 0 },
        {
          scale: 1,
          duration: 0.6,
          ease: 'expo.out'
        },
        1
      )
    }

    return tl
  }

  animateContact() {
    const tl = gsap.timeline({ paused: true })
    let delay = 0

    if (this.el.querySelector('.o-header .-surtitle')) {
      tl.call(
        () => {
          this.el.querySelector('.o-header .-surtitle').classList.add('is-inview')
        },
        null,
        delay
      )
      delay += 0.2
    }

    if (this.el.querySelector('.o-header .-h2')) {
      tl.call(
        () => {
          this.el.querySelector('.o-header .-h2').classList.add('is-inview')
        },
        null,
        delay
      )
      delay += 0.2
    }

    if (this.el.querySelector('.o-header .-c2')) {
      tl.call(
        () => {
          this.el.querySelector('.o-header .-c2').classList.add('is-inview')
        },
        null,
        delay
      )
    }

    tl.call(
      () => {
        this.el.querySelector('.o-page_content').classList.add('is-inview')
      },
      null,
      delay
    )

    return tl
  }

  animateDefault() {
    const tl = gsap.timeline({ paused: true })
    let delay = 0

    if (this.el.querySelector('.o-header .-surtitle')) {
      tl.call(
        () => {
          this.el.querySelector('.o-header .-surtitle').classList.add('is-inview')
        },
        null,
        delay
      )
      delay += 0.2
    }

    if (this.el.querySelector('.o-header .-h2')) {
      tl.call(
        () => {
          this.el.querySelector('.o-header .-h2').classList.add('is-inview')
        },
        null,
        delay
      )
      delay += 0.2
    }

    if (this.el.querySelector('.o-header .-c2')) {
      tl.call(
        () => {
          this.el.querySelector('.o-header .-c2').classList.add('is-inview')
        },
        null,
        delay
      )
    }

    tl.call(
      () => {
        this.el.querySelector('.o-page_contents').classList.add('is-inview')
      },
      null,
      delay
    )

    return tl
  }

  destroy() {
    this.TL?.kill()

    window.removeEventListener('p-loaded', this.initTL)
    window.removeEventListener('p-animate', this.animate)
  }
}
